import { useTranslation } from "react-i18next";
import { formatMetric, hourSlot, WEEKDAYS } from "../busy-times-utils";

const slotLabel = (cell) =>
  `${WEEKDAYS[cell.weekday - 1]} ${hourSlot(cell.hour)}`;

const PeaksCard = ({ busy, waiting = false }) => {
  const { t } = useTranslation("coaching-portal");
  const unit = t(`doorAccess.busy.unit.${busy.metric}`);
  const avgTag =
    busy.metric === "average" ? t("doorAccess.busy.peaks.avg") : "";
  const quiet = busy.quietest[0];
  const perDay = Math.round(busy.averagePerDay);
  const peaks = busy.peaks.map(slotLabel).join(", ");

  return (
    <div className="door-card door-peaks">
      <div>
        <h3>{t("doorAccess.busy.peaks.title")}</h3>
        <p className="door-muted">
          {waiting
            ? t("doorAccess.busy.peaks.waiting")
            : t("doorAccess.busy.peaks.subtitle", { unit })}
        </p>
      </div>
      {busy.peaks.length ? (
        <ol>
          {busy.peaks.map((cell, index) => (
            <li key={`${cell.weekday}-${cell.hour}`}>
              <span className="door-peaks__rank">{index + 1}</span>
              <span className="door-grow">{slotLabel(cell)}</span>
              <b>{formatMetric(cell[busy.metric], busy.metric)}</b>
              <span className="door-muted door-peaks__unit">{avgTag}</span>
            </li>
          ))}
        </ol>
      ) : (
        <p className="door-peaks__empty">{t("doorAccess.busy.peaks.none")}</p>
      )}
      {!waiting && (
        <div className="door-peaks__facts">
          <div>
            <span className="door-peaks__label">
              {t("doorAccess.busy.peaks.avgDay")}
            </span>
            <b>{perDay.toLocaleString("en-US")}</b>
            <span className="door-muted">
              {t("doorAccess.busy.peaks.visits")}
            </span>
          </div>
          <div>
            <span className="door-peaks__label">
              {t("doorAccess.busy.peaks.quietest")}
            </span>
            <b className="door-peaks__quiet">
              {quiet ? slotLabel(quiet) : "–"}
            </b>
            <span className="door-muted">
              {quiet
                ? t("doorAccess.busy.peaks.quietestSub", {
                    value: formatMetric(quiet[busy.metric], busy.metric),
                    unit: avgTag || unit,
                  })
                : ""}
            </span>
          </div>
        </div>
      )}
      {busy.peaks.length > 0 && (
        <p className="door-peaks__summary">
          {t("doorAccess.busy.peaks.summary", {
            peaks,
            quiet: quiet ? slotLabel(quiet) : "–",
            avg: perDay.toLocaleString("en-US"),
          })}
        </p>
      )}
    </div>
  );
};

export default PeaksCard;
